import { $auth, $store } from "../main";
import api from "./api";
import router from "../router";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
const api_root = process.env["VUE_APP_ROOT_API"];

let requestsPending = 0;
api.interceptors.request.use(
  (config) => {
    // requestsPending++;
    // if (requestsPending > 0) store.dispatch(`show_loader`);
    const tenant = ($auth && $auth.user[tenant_key] && $auth.user[tenant_key]["tenant"]) || "";
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.common["Authorization"] = `Bearer ${token}`;
      config.headers.common["Tenant"] = tenant;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    // requestsPending--;
    // if (requestsPending == 0) {
    //   store.dispatch(`hide_loader`);
    //   store.dispatch(`hide_label`);
    // }
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    requestsPending--;
    if (requestsPending == 0) {
      $store.dispatch(`hide_loader`);
      $store.dispatch(`hide_label`);
    }
    if (error.response.status) {
      switch (error.response.status) {
        case 400:
          $store.dispatch("update_message", { msg: "Error" });
          // $store.dispatch("show_message");
          break;
        case 403:
          router.replace({
            path: "/error",
            query: { redirect: router.currentRoute.fullPath },
          });
          break;
      }
      return Promise.reject(error.response);
    }
  }
);

const computedUrl = (url, data) => {
  if (!url || !data) throw new Error("Error computing url, url or data params empty");
  return eval("`" + url + "`");
};

export const axios_get = (url, data = {}, params = null) => {
  let computed_url = computedUrl(url, data);
  return new Promise((resolve, reject) => {
    api
      .get(`${computed_url}`, params ? { params } : null)
      .then((response) => {
        resolve(response);
      })
      .catch((e) => {
        console.log(e.response);
        reject(e);
      });
  });
};

export const axios_post = (url, payload, data = {}) => {
  let computed_url = computedUrl(url, data);
  return new Promise((resolve, reject) => {
    api
      .post(`${computed_url}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((e) => {
        console.log(e.response);
        reject(e);
      });
  });
};

export const axios_put = (url, data = {}, payload) => {
  let computed_url = computedUrl(url, data);
  return new Promise((resolve, reject) => {
    api
      .put(`${computed_url}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((e) => {
        console.log(e.response);
        reject(e);
      });
  });
};

export const axios_delete = (url, data = {}, params) => {
  let computed_url = computedUrl(url, data);
  return new Promise((resolve, reject) => {
    api
      .delete(`${computed_url}`, params ? { data: params } : null)
      .then((response) => {
        resolve(response);
      })
      .catch((e) => {
        console.log(e.response);
        reject(e);
      });
  });
};
